export interface SpecSummary {
  /** Numbered `## 1. Title` sections. */
  sections: number;
  /** Bullets under an Acceptance heading. */
  criteria: number;
}

/** The detected-sections panel on the spec step. Numbered sections are what blame and work packages point back to. */
export function detectSpec(text: string): SpecSummary {
  const lines = text.split(/\r?\n/);
  let sections = 0;
  let criteria = 0;
  let inAcceptance = false;
  for (const line of lines) {
    if (/^##\s+\d+[.)]?\s+\S/.test(line)) {
      sections++;
      inAcceptance = false;
    } else if (/^#{1,3}\s+acceptance\b/i.test(line)) {
      inAcceptance = true;
    } else if (/^#{1,3}\s+\S/.test(line)) {
      inAcceptance = false;
    } else if (inAcceptance && /^\s*[-*]\s+\S/.test(line)) {
      criteria++;
    }
  }
  return { sections, criteria };
}
